import React, { useEffect, useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
// import "swiper/css/navigation";
import { motion } from "framer-motion";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Link, useNavigate } from "react-router-dom";
import { AUTH_IMG, LISPENDES_LOGO_ANAMBRA } from "../../assets";
const swiperData = [
  {
    heading: "Streamline Property Litigation Management with Ease.",
    description:
      "Gain seamless access to information regarding properties under litigation in Anambra State. The platform provides an easy way for users to check if properties are subject to ongoing lawsuits.",
  },
];
function AuthLayout({ children }: { children: React.ReactNode }) {
  // @ts-ignore
  const swiperRef = useRef<Swiper | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    if (swiperRef.current) {
      // @ts-ignore
      swiperRef.current.swiper.on("slideChange", (swiper: any) => {
        setActiveIndex(swiper.realIndex);
      });
    }
  }, []);

  return (
    <main className="w-full flex items-start h-screen overflow-hidden">
      <div
        style={{
          backgroundImage: `url(${AUTH_IMG})`,
          backgroundRepeat: "no-repeat",
          backgroundPositionX: "30px",
          backgroundPositionY: "400px",
        }}
        className="w-[900px] h-screen relative bg-lightGold lg:flex hidden items-start flex-col gap-y-16 p-6"
      >
        <div>
          <img
            src={LISPENDES_LOGO_ANAMBRA}
            alt=""
            className="w-[200px] h-[30.2px] cursor-pointer"
            onClick={() => navigate("/")}
          />
        </div>
        <div className="flex flex-col items-start">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay]}
            autoplay={{ delay: 5000 }}
            slidesPerView={1}
            loop={true}
            className="w-[499px]"
          >
            {swiperData.map((data, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col gap-y-4 ">
                  <motion.span
                    initial={{ x: -50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="text-2xl font-bold text-primary-300"
                  >
                    {data.heading}
                  </motion.span>
                  <motion.span
                    initial={{ x: 50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                    className="text-primary-50 font-medium text-sm"
                  >
                    {data.description}
                  </motion.span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="flex justify-center mt-4 space-x-1">
            {[0, 1, 2].map((index) => (
              <div
                key={index}
                className={`h-2 transition-all duration-300 rounded-full ${
                  activeIndex === index
                    ? "w-5 bg-globalGold"
                    : "w-2 bg-gray-400"
                }`}
              ></div>
            ))}
          </div>
        </div>

        <div
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.6) 50%, #FFFFFF 100%)",
          }}
          className="absolute bottom-0 left-0 w-full h-1/4"
        ></div>
      </div>
      <div className="w-full h-[100vh] overflow-y-scroll lg:p-16 p-5 bg-white flex items-center justify-center ">
        {children}
      </div>
    </main>
  );
}

export default AuthLayout;
